
import {Component, Vue } from "vue-property-decorator";
import PageBase from "./PageBase.vue";

@Component({
    components:{
        PageBase
    }
})

export default class StepBase extends Vue {
    
};
